const StandardFieldCode = {
    CreationDate: '_creationDate_',
    Author: '_author_',
    Version: '_version_',
    Fulltext: '_fulltext_',
    DocumentId: '_documentID_',
};
export default StandardFieldCode;
